const genMaxCountStyle = (token) => {
    const { componentCls } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [`${componentCls}-max-count`]: {
            [`${itemCls}-ellipsis`]: {
                [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: {
                    color: token.colorTextDescription,
                },
            },
        },
    };
};
export default genMaxCountStyle;
